import PropTypes from 'prop-types';

const CameraIcon = ({ className = '' }) => (
  // <div>
  (<svg
    width="62"
    height="40"
    viewBox="0 0 62 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="0.666748" y="0.261719" width="45" height="39" fill="#0A0777" />
    <path
      d="M46.1667 18.7617L61.1667 6.76172V30.7617L46.1667 18.7617Z"
      fill="#C9E3F7"
    />
  </svg>)

  // </div>
);

CameraIcon.propTypes = {
  className: PropTypes.string
};

export default CameraIcon;
